// ! this file should only be directly modified in the packages/corso-types/corso-shopify-extensions/shared.ts file
// ! IT SHOULD NOT CONTAIN ANY IMPORTS!!!!!
// --------- DEFAULTS ---------
export const SHIPPING_PLUS_DEFAULTS = {
    // -- General Settings
    isEnabled: false,
    isRateTableCacheEnabled: false,
    isWidgetDebugEnabled: false,
    isFreeShippingOptInEnabled: false,
    isUpdateExistingDiscountsEnabled: false,
    backupRateIds: [],
    enabledCartAttributes: [],
    // -- Delivery Customization Settings
    deliveryCustomization: {
        isEnabled: true,
        isReorderShippingLinesEnabled: false,
        hideRateNames: [],
        hideRateNamesOptOut: [],
    },
    // -- UI settings for the Widget + Modal-------
    label: 'Learn About Delivery Guarantee',
    freeShippingLabel: `Apply Free Shipping Discount`,
    freeShippingDescription: 'If you choose not to get Delivery Guarantee, we are not responsible for lost, damaged, or stolen packages.',
    description: `Delivery Guarantee provides immediate resolution in case of lost, damaged, or stolen packages.`,
};
const CHECKOUT_PLUS_DEFAULTS = {
    hideWidgetSkus: [],
    disabledCustomerTags: [],
    disabledUrls: [],
    cloneOmitAttributes: [],
    isQueryAjaxCartApiEnabled: true,
    cartRefreshMethod: 'reloadPage',
    isEnabled: false,
    isDirectCheckoutEnabled: false,
    shouldProtectCompanyCarts: true,
    removeProtectionProductOnPageLoad: true,
    cartRetrievalKey: 'cart',
    shouldQueryShadowDom: false,
    areSubscriptionsEnabled: false,
    cartChangeDetectionMethod: 'cartWatcher',
    checkoutButtonText: 'Checkout+ ({{subtotal}})',
    productCheckoutExtensionDescription: 'For lost, damaged, or stolen packages',
    productCheckoutExtensionTitle: 'Delivery Guarantee',
    cartSelectors: [
        'cart-items', // dawn theme
        'cart-drawer-items', // dawn theme
        '#cart-notification-product', // dawn theme
    ],
    displayCountryCodes: ['US'],
    checkoutSelectors: ['button[name="checkout"]'],
    checkoutAction: 'addVariantToCart',
    customCss: `
  :root {
  --corso-button-border-color: black;
  --corso-button-border-width: 1px;
  --corso-button-text-decoration: none;
  --corso-button-padding: 8px;
}`,
    elements: [
        {
            title: 'Checkout without delivery guarantee',
            description: null,
            selectors: [
                '#corso-checkout-plus-button', // corso placeholder
                '.cart__ctas', // dawn theme
                '#cart-notification-form', // dawn theme
            ],
            insertionStrategy: 'insertAdjacentAfterEnd',
            kind: 'altCheckoutButton',
            imgHtmlContent: '',
        },
        {
            title: 'Delivery Guarantee',
            description: 'For lost, damaged, or stolen packages',
            imgUrl: 'https://cdn.corso.com/img/Default%20box.png',
            imgHtmlContent: '',
            selectors: [
                '#corso-checkout-plus-info', // corso placeholder
                '.cart__ctas', // dawn theme
                '.cart-notification__links', // dawn theme
            ],
            insertionStrategy: 'insertAdjacentBeforeBegin',
            kind: 'checkoutInfo',
        },
    ],
    shopNow: {
        placement: 'bottom left',
        hideSelectors: ['shopify-accelerated-checkout'],
        checkoutButtonText: 'Finish My Return',
    },
};
export const WIDGET_DEFAULTS = {
    modal: {
        imageUrl: 'https://cdn.corso.com/img/delivery-guarantee-banner.png',
        title: `Delivery Guarantee`,
        description: "We do our best to make sure your package arrives quickly and safely. In case anything unexpected happens to your package, we recommend adding delivery guarantee to your order. For a small optional amount, you don't have to worry.",
        benefits: [
            {
                title: `Our delivery guarantee has you covered`,
                description: 'For loss, damage, theft, missing or wrong items, return to sender, and other carrier mistakes.',
            },
            {
                title: 'Fast, Friendly Support',
                description: 'Get quick help from the friendly team at Corso. They have seen everything and have a 97% customer satisfaction score.',
            },
            {
                title: 'Easy Resolutions',
                description: 'Our customer portal makes it easy to report a shipping issue and fast-track a replacement.',
            },
        ],
    },
    checkoutExtensionProduct: {
        isDefaultOptIn: false,
    },
    shippingPlus: SHIPPING_PLUS_DEFAULTS,
    checkoutPlus: CHECKOUT_PLUS_DEFAULTS,
};
export const CorsoCurrencyMetaobject = {
    type: 'currency',
    handle: 'corso_currency',
    fieldKey: 'conversion_rate',
    value: 100_000,
};
export const CheckoutPlusUrlParam = {
    sfToken: 'sfToken',
    shop: 'shop',
    themeAppEmbed: 'themeAppEmbed',
};
export const CorsoMetafieldNamespace = `$app:corso`;
export const CorsoMetafieldKey = {
    WIDGET_CONFIG: 'widget_config',
    SHIPPING_PLUS_PRICE: 'plus_shipping_price',
    SHIPPING_PROTECTION: 'is_shipping_protected',
    // the pricing set for the store
    CART_PRICE_RANGES: 'cart_price_ranges',
    EXTERNAL_STOREFRONT_CONFIG: 'external_storefront_config',
    SHIPPING_PROTECTION_PRODUCT_SET_NAME: 'shipping_protection_product_set_name',
    SHIPPING_PROTECTION_PRODUCT_SET_ID: 'shipping_protection_product_set_id',
};
export const CORSO_FUNCTION_NAME = {
    reorderShippingLines: 'Corso Reorder Shipping Lines',
    shippingDiscount: 'Corso Shipping Discount',
};
//  the title of the delivery customization
export const CORSO_DELIVERY_CUSTOMIZATION_TITLE = 'Corso Delivery Customization';
// the name of the carrier service
export const CORSO_CARRIER_SERVICE_NAME = 'Corso';
// ---------- CART ATTRIBUTE -----------------------------------
//! CPO demands we don't change these due to custom brand implementations
//! attributes must be between 3-30 characters in length
export const CorsoCartAttribute = {
    plusTitle: '_corsoSpTitle',
    plusPrice: '_corsoSpPrice',
    plusEstimatedDeliveryStart: '_corsoSpEstDeliveryStart',
    plusEstimatedDeliveryEnd: '_corsoSpEstDeliveryEnd',
    dgShippingGuaranteed: '_corsoSpGuarantee',
    discountName: '_corsoSpDiscount',
    dgGuaranteeOptOutOn: '_corsoSpDgOptOutOn',
    dgCheckboxSelected: '_corsoSpDgOptOut',
    //! do not modify this without updating the corso-reorder-shipping-lines function
    cpReorderOptIn: '_corsoCpReorderOptIn',
    cpCartOptOut: '_corsoCpCartOptOut',
};
export const CorsoLineItemProperty = {
    appliedGiftCardCodes: '_corsoAppliedGiftCardCodes',
    customer: '_corsoCustomer',
};
export const CheckoutPlusInsertionStrategy = {
    insertAdjacentBeforeBegin: 'insertAdjacentBeforeBegin',
    insertAdjacentAfterBegin: 'insertAdjacentAfterBegin',
    insertAdjacentBeforeEnd: 'insertAdjacentBeforeEnd',
    insertAdjacentAfterEnd: 'insertAdjacentAfterEnd',
};
export const CheckoutPlusAction = {
    setShippingPlusReorderRate: 'setShippingPlusReorderRate',
    setShippingPlusOptOut: 'setShippingPlusOptOut',
    addVariantToCart: 'addVariantToCart',
};
export const CheckoutPlusElementKind = {
    altCheckoutButton: 'altCheckoutButton',
    checkoutInfo: 'checkoutInfo',
};
export const CartChangeDetectionMethod = {
    cartWatcher: 'cartWatcher',
    selectorObserver: 'selectorObserver',
};
export const CheckoutPlusTemplateVariable = {
    subtotal: 'subtotal',
    quotePrice: 'quotePrice',
};
export const CheckoutPlusRefreshMethod = {
    reloadPage: 'reloadPage',
    none: 'none',
};
export const ShopifyExtensionHandle = {
    checkoutExtensionProduct: 'checkout-extension-product',
    checkoutExtensionShipping: 'checkout-extension-shipping',
    customerAccount: 'customer-account',
    deliveryEstimate: 'delivery-estimate',
    deliveryGuarantee: 'delivery-guarantee',
    embeddedUi: 'embedded-ui',
    orderEdit: 'order-edit',
    removeProduct: 'remove-product',
    checkoutPlusScript: 'checkout-plus-script',
    checkoutPlusThemeAppEmbed: 'checkout-plus-theme-app-embed',
};
export const CorsoCheckoutPlusEmbedHandle = 'checkoutPlus';
const mockWidgetConfig = (partial) => ({
    ...partial,
    modal: {
        imageUrl: 'https://cdn.corso.com/img/shipping-plus-hexagon-banner.png',
        title: `Shipping Plus`,
        description: "Get streamlined resolution in case anything unexpected happens to your package. For a small optional amount, you don't have to worry.",
        benefits: [
            {
                title: `Shipping Plus has you covered`,
                description: 'For loss, damage, theft, missing or wrong items, return to sender, and other carrier mistakes.',
            },
            {
                title: 'Fast, Friendly Support',
                description: 'Get quick help from the friendly team at Corso. They have seen everything and have a 97% customer satisfaction score.',
            },
            {
                title: 'Easy Resolutions Replacements',
                description: 'Our Shipping Plus customer portal makes it very easy to report a shipping issue and fast-track a replacement.',
            },
        ],
    },
    shippingPlus: {
        isFreeShippingOptInEnabled: false,
        deliveryCustomization: {
            hideRateNames: [],
            isEnabled: true,
            isReorderShippingLinesEnabled: false,
        },
        label: 'Learn About Shipping Plus',
        freeShippingLabel: `I've Read The Free Shipping Policy`,
        freeShippingDescription: 'If you select a free shipping option, we are not responsible for shipping mistakes or stolen packages.',
        description: `If you don't select a Shipping Plus option, we are not responsible for shipping mistakes or stolen packages.`,
    },
    checkoutPlus: CHECKOUT_PLUS_DEFAULTS,
    externalStorefrontId: 'test-storefront-id',
});
const mockShippingCode = (partial) => ({
    ...partial,
    rateKind: 'plus',
});
export const extensionTestUtils = {
    mockShippingCode,
    mockWidgetConfig,
};
export function decodeCorsoShippingCode(code) {
    try {
        if (!code)
            return null;
        const parsed = JSON.parse(code);
        if (typeof parsed === 'object' && parsed !== null && 'rateKind' in parsed) {
            return parsed;
        }
        // * kept as an eslint-disable due to this shared file being used in extensions, and they currently still use ESLint only
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (error) {
        /* empty */
    }
    return null;
}
//# sourceMappingURL=shared.js.map